import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  error: null,
};

const hostsSlice = createSlice({
  name: "hosts",
  initialState,
  reducers: {
    initializeHost: (state, action) => {
      state.data = action.payload;
    },
    clearHosts: state => {
      state.data = [];
    },
    addHost: (state, action) => {
      if (!Array.isArray(state.data)) {
        state.data = [];
      }
      state.data.push(action.payload);
    },
    updateHost: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.data.findIndex(host => host.id === id);
      if (index !== -1) {
        state.data[index] = { ...state.data[index], ...updates };
      }
    },
    deleteHost: (state, action) => {
      state.data = state.data.filter(host => host.id !== action.payload);
    },
  },
});

export const { initializeHost, addHost, updateHost, deleteHost, clearHosts } = hostsSlice.actions;

export default hostsSlice.reducer;
